import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import Actions from '@/actions';
import { MENU_CODE_NAV } from "@/core/Consts";


const NavContext = createContext({
  navData: [],
  loading: true,
  refresh: () => {},
});

export const useNavData = () => useContext(NavContext);

export const NavProvider = ({ children }) => {
  const [navData, setNavData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchNavData = useCallback(async () => {
    setLoading(true);
    try {
      const action = await Actions.queryHomePageByCode(MENU_CODE_NAV);
      const { type, payload } = action;
      if (type === 'HOME_PAGE_BY_CODE') {
        const { blocks = [] } = payload || {};
        setNavData(blocks);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchNavData();
  }, [fetchNavData]);

  const value = {
    navData,
    loading,
    refresh: fetchNavData,
  };

  return <NavContext.Provider value={value}>{children}</NavContext.Provider>;
};
